import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowOutTopLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-out-top-left, undock, box, arrow"><path d="M6.75 13.75V21.25H21.25V6.75H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 4.75L10.25 10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 10.25V3.75H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowOutTopLeft;
